// 認証必須ルートのガード
// Stage 2C T9:requireSystemAdmin=true を渡すと system_admin role 必須、
// 　　　　　未所持なら /dashboard へリダイレクト（管理者メニュー専用ルート用）。
// Stage 3C:requireAnyRole=["system_admin","editor"] を渡すと
//          指定 role 集合のいずれか必須、未所持なら redirectTo へリダイレクト。

import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

interface ProtectedRouteProps {
  children: ReactNode;
  /** Stage 2C T9:system_admin role 必須 */
  requireSystemAdmin?: boolean;
  /** Stage 3C:指定 role 集合のいずれか必須 */
  requireAnyRole?: string[];
  /** 上記条件 NG 時のリダイレクト先(デフォルト /settings) */
  redirectTo?: string;
}

export function ProtectedRoute({
  children,
  requireSystemAdmin = false,
  requireAnyRole,
  redirectTo = "/settings",
}: ProtectedRouteProps) {
  const { user, loading, isSystemAdmin, hasAnyRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="login-splash">
        <div className="login-splash-spinner" />
        <p>認証状態を確認しています...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // requireSystemAdmin が優先(後方互換)
  if (requireSystemAdmin && !isSystemAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // requireAnyRole(指定 role 集合のいずれか)
  if (requireAnyRole && !hasAnyRole(requireAnyRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}